
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"1","y":"1","width":"22","height":"22","rx":"7","stroke":"#A7A7A7","stroke-width":"2"}}),_c('path',{attrs:{"d":"M9.237 14.794l-.706.708 1.416 1.412.707-.708-1.417-1.412zm8.893-6.088a1 1 0 00-1.416-1.412l1.416 1.412zm-7.476 7.5l7.476-7.5-1.416-1.412-7.477 7.5 1.416 1.412z","fill":"#A7A7A7"}}),_c('path',{attrs:{"d":"M9.238 16.457l.707.707 1.415-1.414-.708-.707-1.414 1.414zm-2.53-5.359a1 1 0 10-1.414 1.414l1.414-1.414zm3.944 3.945l-3.944-3.945-1.414 1.414 3.944 3.945 1.414-1.414z","fill":"#A7A7A7"}})])
          )
        }
      }
    